import { render, staticRenderFns } from "./CompetenceUnitCell.vue?vue&type=template&id=f1ad450c&scoped=true"
import script from "./CompetenceUnitCell.vue?vue&type=script&lang=js"
export * from "./CompetenceUnitCell.vue?vue&type=script&lang=js"
import style0 from "./CompetenceUnitCell.vue?vue&type=style&index=0&id=f1ad450c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ad450c",
  null
  
)

export default component.exports